import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthServiceZ } from '../../authentification/auth-service.service';
import { MainSupportService } from '../../pages/support/main-support.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedService } from './../../shared/shared.service';
import { AddressService, City, AddressSearchResult } from '../../shared/address.service';

@Component({
  selector: 'app-new-support-ticket',
  templateUrl: './new-support-ticket.component.html',
  styleUrls: ['./new-support-ticket.component.scss'],
})
export class NewSupportTicketComponent implements OnInit {
  newTicket;
  user;
  gouvernorats = [];
  selectedDivision = 0;

  // New address system
  cities: City[] = [];
  selectedCity: City | null = null;
  selectedAddress: AddressSearchResult | null = null;
  addressSearchResults: AddressSearchResult[] = [];
  showAddressSuggestions: boolean = false;
  isSelectingAddress = false;

  ticketType = [
    {
      num: 1,
      name: 'Standard',
    },

    {
      num: 5,
      name: 'Reporter un retard de livraison',
    },
    {
      num: 2,
      name: 'Changer le prix du colis',
    },
    {
      num: 3,
      name: "Changer l'adresse du client",
    },
    {
      num: 4,
      name: 'Changer le numéro de téléphone',
    },
  ];

  submittedTicket;
  packingSlips;
  hasExistingTicket = true;
  loading;
  constructor(
    private fb: FormBuilder,
    private authService: AuthServiceZ,
    private supportService: MainSupportService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NewSupportTicketComponent>,
    public router: Router,
    private sharedService: SharedService,
    private addressService: AddressService
  ) {
    this.user = this.authService?.credentials?.user;
    this.gouvernorats = this.sharedService.gouvernorats;

    this.packingSlips = [data.delivery.dropOffjobRequest];
    console.log(this.packingSlips);
    this.newTicket = this.fb.group({
      title: [''],
      description: [''],
      service: [''],
      business: [this.user?.business],
      packingSlip: [this.packingSlips[0]?._id],
      ticketType: [undefined, Validators.required],
      status: [1],
      newPhone: [''],
      newAmount: [],
      newAddress: [''],
      newCity: [''],
      newSubDivision: [''],
      newZone: [''],
      newAddressObject: [null],
    });
  }

  ngOnInit(): void {
    this.hasExistingTicket = false;
    this.loadCities();
  }

  get ticketControls() {
    return this.newTicket.controls;
  }
  get p() {
    return this.newTicket.controls;
  }

  closedialog() {
    this.dialogRef.close();
  }

  addTicket(): void {
    this.submittedTicket = true;
    if (this.newTicket.valid) {
      if (this.newTicket.value.ticketType == 1) {
      }
      if (this.newTicket.value.ticketType == 2) {
        this.newTicket.patchValue({
          title:
            'Changement du prix à ' + this.newTicket.value.newAmount + ' DT',
        });
      }
      if (this.newTicket.value.ticketType == 3) {
        let addressTitle = "Changement d'adresse à " + this.newTicket.value.newAddress;
        if (this.selectedCity) {
          addressTitle += ' ' + this.selectedCity.name;
        }
        if (this.selectedAddress) {
          addressTitle += ', ' + this.selectedAddress.displayName;
        }
        this.newTicket.patchValue({
          title: addressTitle,
        });
      }
      if (this.newTicket.value.ticketType == 4) {
        this.newTicket.patchValue({
          title:
            'Changement du numéro de téléphone à ' +
            this.newTicket.value.newPhone,
        });
      }
      if (this.newTicket.value.ticketType == 5) {
        this.newTicket.patchValue({
          title:
            'Reporter un retard de livraison colis N° ' +
            this.packingSlips[0].nid,
        });
      }

      // Prepare request data with address object for address change tickets
      const ticketData = { ...this.newTicket.value };

      if (Number(this.newTicket.value.ticketType) === 3) {
        // Always build address object for address change tickets
        const addressObject = this.buildAddressObject() || {
          address_text: this.newTicket.value.newAddress || '',
          city_id: null,
          city_name: this.newTicket.value.newCity || '',
          district_id: null,
          district_name: this.newTicket.value.newSubDivision || '',
          neighborhood_id: null,
          neighborhood_name: this.newTicket.value.newZone || ''
        };

        // ALWAYS add newAddressObject to ticket data
        ticketData['newAddressObject'] = addressObject;
      }

      this.supportService
        .addTicket(ticketData)
        .then((d) => {
          this.submittedTicket = false;
          this.dialogRef.close(true);
        })
        .catch((err) => {
          this.submittedTicket = false;
          this.dialogRef.close(false);
        });
    }
  }

  selectingTicketType(event) {
    // 1 standard
    // 2 change price
    // 3 change address
    // 4 change phone number

    let fields = [
      'title',
      'description',
      'service',
      'packingSlip',
      'status',
      'newPhone',
      'newAmount',
      'newAddress',
      'newCity',
      'newSubDivision',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.updatenewTicketFormValidatorsToNull(fields[i]);
    }

    this.submittedTicket = false;
    console.log(event.num);
    let type = event.num;

    this.newTicket.patchValue({
      ticketType: type,
    });

    if (type == 1) {
      this.setnewTicketFormValidatorsToRequiredAgain('title');
      this.setnewTicketFormValidatorsToRequiredAgain('description');
      this.setnewTicketFormValidatorsToRequiredAgain('service');
    }

    if (type == 2) {
      this.setnewTicketFormValidatorsToRequiredAgain('newAmount');
      this.setnewTicketFormValidatorsToRequiredAgain('packingSlip');
      this.newTicket.patchValue({
        service: 'Service Commercial',
      });
    }
    if (type == 3) {
      this.setnewTicketFormValidatorsToRequiredAgain('newAddress');
      this.setnewTicketFormValidatorsToRequiredAgain('newCity');
      this.setnewTicketFormValidatorsToRequiredAgain('newSubDivision');
      this.setnewTicketFormValidatorsToRequiredAgain('packingSlip');
      this.newTicket.patchValue({
        service: 'Service Commercial',
      });
    }
    if (type == 4) {
      this.setnewTicketFormValidatorsToRequiredAgain('newPhone');
      this.setnewTicketFormValidatorsToRequiredAgain('packingSlip');
      this.newTicket.patchValue({
        service: 'Service Commercial',
      });
    }  
      if (type == 5) {
      this.newTicket.patchValue({
        service: 'Service Commercial',
      });
    }
  }

  cityChanged(event) {
    return (this.selectedDivision = this.gouvernorats
      .map((item) => item.division)
      .indexOf(this.p.newCity.value));
  }
  updatenewTicketFormValidatorsToNull(fieldName) {
    // 1 standard
    // 2 change price
    // 3 change address
    // 4 change phone number

    this.newTicket.get(fieldName).clearValidators();
    this.newTicket
      .get(fieldName)
      .updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }

  setnewTicketFormValidatorsToRequiredAgain(fieldName) {
    this.newTicket?.get(fieldName).setValidators([Validators.required]);
    this.newTicket
      ?.get(fieldName)
      .updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }

  // New address methods
  async loadCities() {
    try {
      this.cities = await this.addressService.getCities();
    } catch (error) {
      console.error('Error loading cities:', error);
    }
  }

  onCityChange(cityName: string) {
    this.selectedCity = this.cities.find(city => city.name === cityName) || null;
    this.selectedAddress = null;
    this.addressSearchResults = [];
    this.showAddressSuggestions = false;

    // Update the existing newCity field with the selected city name
    this.newTicket.patchValue({
      newCity: this.selectedCity?.name || '',
      newSubDivision: ''
    });
  }

  searchAddresses(term: string) {
    if (!this.selectedCity || !term || term.length < 2) {
      this.addressSearchResults = [];
      this.showAddressSuggestions = false;
      return;
    }

    this.addressService.searchAddresses(this.selectedCity.id, term)
      .then((results) => {
        this.addressSearchResults = results;
        this.showAddressSuggestions = results.length > 0;
      })
      .catch((error) => {
        console.error('Error searching addresses:', error);
        this.addressSearchResults = [];
        this.showAddressSuggestions = false;
      });
  }

  selectAddress(address: AddressSearchResult) {
    this.isSelectingAddress = true;
    this.selectedAddress = address;

    // Set newSubDivision to district name, not the full displayName
    let districtName = '';
    let neighborhoodName = '';

    if (address.type === 'district') {
      districtName = address.name;
      neighborhoodName = '';
    } else if (address.type === 'neighborhood') {
      // For neighborhoods, use the parent district name
      districtName = address.district_name || '';
      neighborhoodName = address.name;
    }

    this.newTicket.patchValue({
      newSubDivision: districtName
    });

    // Store zone separately if neighborhood is selected
    if (neighborhoodName) {
      this.newTicket.patchValue({
        newZone: neighborhoodName
      });
    }

    this.addressSearchResults = [];
    this.showAddressSuggestions = false;
    setTimeout(() => {
      this.isSelectingAddress = false;
    }, 100);
  }

  onAddressBlur(event: any) {
    if (!this.isSelectingAddress) {
      setTimeout(() => {
        this.showAddressSuggestions = false;
      }, 200);
    }
  }

  buildAddressObject() {
    // Try to find city from form value if selectedCity is not set
    let cityToUse = this.selectedCity;

    if (!cityToUse && this.newTicket.value.newCity) {
      // Fallback: search for city in cities array by name
      cityToUse = this.cities.find(city => city.name === this.newTicket.value.newCity) || null;
    }

    // If still no city, we can't build address object
    if (!cityToUse) {
      return null;
    }

    // address_text should be the street address from the newAddress field, NOT district/zone
    const streetAddress = this.newTicket.value.newAddress || '';

    const addressObject: any = {
      address_text: streetAddress,  // Just the street address, no zone
      city_id: cityToUse.id,
      city_name: cityToUse.name,
      district_id: null,
      district_name: null,
      neighborhood_id: null,
      neighborhood_name: null
    };

    // If user selected from dropdown, use those values (with IDs)
    if (this.selectedAddress) {
      if (this.selectedAddress.type === 'district') {
        addressObject.district_id = this.selectedAddress.id;
        addressObject.district_name = this.selectedAddress.name;
      } else if (this.selectedAddress.type === 'neighborhood') {
        addressObject.neighborhood_id = this.selectedAddress.id;
        addressObject.neighborhood_name = this.selectedAddress.name;
        // Get district ID from the selected address
        if (this.selectedAddress.district_id) {
          addressObject.district_id = this.selectedAddress.district_id;
        }
        // Also include the parent district name if available
        if (this.selectedAddress.district_name) {
          addressObject.district_name = this.selectedAddress.district_name;
        }
      }
    } else {
      // Fallback: If user didn't select from dropdown, use form values
      // (in case they typed values manually or selection didn't register)
      if (this.newTicket.value.newSubDivision) {
        addressObject.district_name = this.newTicket.value.newSubDivision;
      }
      if (this.newTicket.value.newZone) {
        addressObject.neighborhood_name = this.newTicket.value.newZone;
      }
    }

    return addressObject;
  }
}
